<template>
  <div>
    <v-select
      v-model="categoriaSelect"
      :items="categoriaSelect ? [categoriaSelect] : itemsCategoria"
      item-text="name"
      item-value="id"
      :label="categoriaSelect ? 'Categoríax' : 'Categoría'"
      :outlined="outlined"
      :readonly="!categoriaSelect"
      :clearable="!!categoriaSelect"
      @mousedown="!categoriaSelect && (dialogCategoria = true)"
      @click="categoriaSelect && changeCategoria()"
      @click:clear="categoriaSelect && clearData()"
    >
      <template v-slot:prepend-inner v-if="categoriaSelect">
        <v-icon :color="categoriaSelect.color">mdi-circle</v-icon>
      </template>
    </v-select>

    <v-dialog v-model="dialogCategoria" width="500">
      <v-card>
        <v-card-title>
          Seleccione una categoría
          <v-spacer></v-spacer>
          <v-icon large @click="dialogCategoria = false">mdi-close</v-icon>
        </v-card-title>
        <v-container>
          <keep-alive>
            <egreso-categoria-tree-select
              :categorias="categorias"
              @process-categoria="setCategoriaRegister"
            ></egreso-categoria-tree-select>
          </keep-alive>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TreeCategoria from "@/views/categorias/consultar/TreeCategoria.vue";
import EgresoCategoriaTreeSelect from "@/components/egresos/EgresoCategoriaTreeSelect";
import EgresoAPI from "@/api/egresos/index.js";

export default {
  name: "EgresoFormCategoriaSelect",
  components: {
    EgresoCategoriaTreeSelect,
  },
  props: {
    categoria: {
      required: false,
      // default: () => ({ categoria: { id: null } }),
      default: null,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      categorias: [],
      dialogCategoria: false,
      categoriaSelect: null,
    };
  },
  computed: {
    itemsCategoria() {
      if (
        !this.categoria ||
        this.categoria.id == null ||
        this.categoria.name == "SIN CATEGORIA"
      ) {
        return [];
      } else {
        return [this.categoria];
      }
    },
  },

  methods: {
    changeCategoria() {
      this.categoriaSelect = null;
      this.dialogCategoria = true;
    },
    clearData() {
      this.categoriaSelect = null;
      this.$emit("clearable", this.categoria);
      this.$emit("process-categoria", null);
    },
    setCategoriaRegister(tp) {
      this.categoriaSelect = tp;
      this.dialogCategoria = false;
      this.$emit("process-categoria", tp);
    },
  },
  mounted() {
    if (
      this.categoria &&
      this.categoria.id !== null &&
      this.categoria.name !== "SIN CATEGORIA"
    ) {
      this.categoriaSelect = this.categoria;
    }
  },
  created() {
    EgresoAPI.index().then((response) => {
      this.categorias = response.data.parent;
    });
  },
};
</script>

<style lang="scss" scoped></style>
